import { render, staticRenderFns } from "./instagramStoryEmbed.vue?vue&type=template&id=63ab8720&scoped=true&"
import script from "./instagramStoryEmbed.vue?vue&type=script&lang=js&"
export * from "./instagramStoryEmbed.vue?vue&type=script&lang=js&"
import style0 from "./instagramStoryEmbed.vue?vue&type=style&index=0&id=63ab8720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab8720",
  null
  
)

export default component.exports